import { Model } from '@vuex-orm/core'

export default class AlternateHotel extends Model {
  declare id: number
  declare propertyId: number | undefined
  declare min_price: number
  declare property_name: string
  declare descriptions: any
  declare property_currency: string
  declare rateName: string
  declare image: string
  declare checkin: string
  declare checkout: string
  declare roomConfigurations: any[]
  declare promoCode: string
  declare city: string
  declare country: string
  declare amenities: any[]

  static entity = 'alternateHotel'
  static primaryKey = 'id'

  static fields () {
    return {
      id: this.uid(),
      propertyId: this.attr(null).nullable(),
      min_price: this.number(0),
      property_name: this.attr(''),
      descriptions: this.attr(''),
      property_currency: this.attr(''),
      rateName: this.attr(''),
      image: this.string(null),
      checkin: this.attr(null),
      checkout: this.attr(null),
      roomConfigurations: this.attr(null),
      promoCode: this.attr(null),
      city: this.attr(null),
      country: this.attr(null),
      amenities: this.attr(null),
    }
  }
}
